import AddressIndex from '@/views/auth/address/index.vue';
import AddressAllList from '@/views/auth/address/AllList.vue';
import PeopleAddressesList from '@/views/auth/address/people.vue';
import OrganizationsAddressesList from '@/views/auth/address/organizations.vue';
import AddressEdit from '@/views/auth/address/_id.vue';
import AddressStammdaten from '@/views/auth/address/_id/stammdaten.vue';
import AddressKulturplatzEntry from '@/views/auth/address/_id/kulturplatz_entry.vue';
import AddressMetadata from '@/views/auth/address/_id/metadata.vue';
import AddressRelations from '@/views/auth/address/_id/AddressRelations.vue';
import AddressChangelog from '@/views/auth/address/_id/changelog.vue';
import LocationList from '@/views/auth/address/locations.vue';
import EventOrganizerList from '@/views/auth/address/event_organizer.vue';
import KulturplatzList from '@/views/auth/address/kulturplatz.vue';
import { getI18nInstance } from '@/i18n';

export default [
    {
        path: '/address',
        component: AddressIndex,
        meta: {
            requiresAuth: true,
            title: () => getI18nInstance().t('adressen'),
        },
        children: [
            {
                path: 'all',
                name: 'address-all',
                component: AddressAllList,
                meta: {
                    mainTitle: () => getI18nInstance().t('adresse'),
                    icon: 'world',
                },
            },
            {
                path: 'people',
                name: 'address-people',
                component: PeopleAddressesList,
                meta: {
                    mainTitle: () => getI18nInstance().t('people'),
                    icon: 'world',
                },
            },
            {
                path: 'organizations',
                name: 'address-organizations',
                component: OrganizationsAddressesList,
                meta: {
                    mainTitle: () => getI18nInstance().t('organizations'),
                    icon: 'world',
                },
            },
            {
                path: 'location',
                name: 'locations-list',
                component: LocationList,
                meta: {
                    mainTitle: () => getI18nInstance().t('locations'),
                    icon: 'address',
                },
            },
            {
                path: 'event_organizer',
                name: 'event_organizer-list',
                component: EventOrganizerList,
                meta: {
                    mainTitle: () => getI18nInstance().t('event_organizers'),
                    icon: 'speaker',
                },
            },
            {
                path: 'kulturplatz',
                name: 'address-kulturplatz',
                component: KulturplatzList,
                meta: {
                    mainTitle: () => getI18nInstance().t('kulturplatz'),
                    icon: 'world',
                },
            },
        ],
    },
    {
        path: '/address/edit/:id',
        component: AddressEdit,
        meta: {
            requiresAuth: true,
            title: () => getI18nInstance().t('adresse'),
        },
        children: [
            {
                path: '/',
                name: 'address-edit',
                component: AddressStammdaten,
            },
            {
                path: 'kulturplatz',
                name: 'address-edit-kulturplatz-entry',
                component: AddressKulturplatzEntry,
            },
            {
                path: 'metadata',
                name: 'address-edit-metadata',
                component: AddressMetadata,
            },
            {
                path: 'relations',
                name: 'address-edit-relations',
                component: AddressRelations,
            },
            {
                path: 'changelog',
                name: 'address-edit-changelog',
                component: AddressChangelog,
            },
        ],
    },
];
